
import { useState, ChangeEvent, ReactNode } from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { User } from "@/types/auth";
import { PasswordFields } from "./PasswordFields";

interface ProfileFormProps {
  user: User | null;
  name: string;
  email: string;
  newPassword: string;
  confirmPassword: string;
  passwordsMatch: boolean;
  passwordMeetsRequirements: boolean;
  isLoading: boolean;
  canSubmit?: boolean;
  setName: (name: string) => void;
  setNewPassword: (password: string) => void;
  setConfirmPassword: (password: string) => void;
  onSaveChanges: () => void;
  children?: ReactNode;
}

export const ProfileForm = ({
  user,
  name,
  email,
  newPassword,
  confirmPassword,
  passwordsMatch,
  passwordMeetsRequirements,
  isLoading,
  canSubmit = true,
  setName,
  setNewPassword,
  setConfirmPassword,
  onSaveChanges,
  children,
}: ProfileFormProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="space-y-2">
        <Label htmlFor="name">Nome</Label>
        <Input 
          id="name" 
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="email">Email</Label>
        <Input 
          id="email" 
          type="email" 
          value={email}
          disabled
        />
      </div>
      
      <PasswordFields 
        newPassword={newPassword}
        confirmPassword={confirmPassword}
        setNewPassword={setNewPassword}
        setConfirmPassword={setConfirmPassword}
        passwordsMatch={passwordsMatch}
        passwordMeetsRequirements={passwordMeetsRequirements}
      />
      
      <div className="md:col-span-2">
        {children}
        
        <Button 
          className="bg-brand-teal hover:bg-brand-teal/90 mt-4"
          onClick={onSaveChanges}
          disabled={isLoading || !canSubmit || (newPassword !== "" && (!passwordsMatch || !passwordMeetsRequirements))}
        >
          {isLoading ? "Salvando..." : "Salvar Alterações"}
        </Button>
      </div>
    </div>
  );
};
